import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from "react";
import { Button, ModalContentBody, ModalContentFooter, ModalContentHeader, Text, } from "@zapier/design-system";
const distillPlanFeatures = ({ premiumAppsLimit, tasks, zapLimit }) => {
    const premiumAppsText = premiumAppsLimit === -1
        ? "unlimited premium apps"
        : `${Number(premiumAppsLimit).toLocaleString()} premium apps`;
    const zapsText = zapLimit === -1
        ? "unlimited Zaps"
        : `${Number(zapLimit).toLocaleString()} Zaps`;
    const tasksText = `${Number(tasks).toLocaleString()} tasks`;
    return `${premiumAppsText}, ${zapsText}, and ${tasksText}!`;
};
const contentMap = {
    TRIAL: () => ({
        bodyText: `You are now experiencing the Zapier Professional plan free for the next 7 days! Take advantage of unlimited premium apps, unlimited Zaps, and ${Number(1000).toLocaleString()} tasks!`,
        headingText: `Free trial started`,
    }),
    UPGRADE: (newPlan) => ({
        bodyText: newPlan
            ? `You just upgraded to the Zapier ${newPlan.name} plan. Take advantage of ${distillPlanFeatures(newPlan)}`
            : "You just upgraded to a new Zapier plan.",
        headingText: `Account upgraded!`,
    }),
};
export const CelebrateModalView = ({ buttonText, celebrationType, newPlan, onClose, }) => {
    const content = celebrationType === "trial"
        ? contentMap.TRIAL()
        : contentMap.UPGRADE(newPlan);
    return (_jsxs(Fragment, { children: [_jsx(ModalContentHeader, { align: "center", children: _jsx(Text, { color: "neutral800", tag: "h1", type: "paragraph1ShortBold", children: content.headingText }) }), _jsx(ModalContentBody, { align: "center", children: _jsx(Text, { color: "neutral700", tag: "p", type: "paragraph3", children: content.bodyText }) }), _jsx(ModalContentFooter, { children: _jsx(Button, { onClick: onClose, children: buttonText }) })] }));
};

// @zapier/upsells@8.0.3 (1de7a616e)
